/** @jsx jsx */

import { ComponentProps, ReactNode } from 'react';

import { Colors, Icon, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';

const styleRoot = css`
  align-items: center;
  display: inline-flex;
  color: ${Colors.TextLink};
  line-height: 1.25;
  font-size: 16px;
`;

type Props = {
  ariaLabel?: string;
  /** Link content. */
  children: ReactNode;
  /** Type of arrow */
  iconName?: 'arrowBigRight' | 'arrowOffsite';
  /** Location to link to */
  href?: string;
  /** Link target */
  target?: ComponentProps<typeof Link>['target'];
  /** On click callback. */
  onClick?: () => void;
};

export default function LinkWithArrow({
  ariaLabel,
  children,
  iconName = 'arrowBigRight',
  href,
  onClick,
  target,
}: Props) {
  return (
    <Link aria-label={ariaLabel} href={href} onClick={onClick} target={target}>
      <span css={styleRoot}>
        {typeof children === 'string' ? (
          <Text color="inherit">{children}</Text>
        ) : (
          children
        )}
        <Spacer width={10} />
        <Icon name={iconName} size={15} />
      </span>
    </Link>
  );
}
